/*
 * Copyright (c) 2020. American Express Company
 */

import { UserModel } from 'src/types/user.model';
import UserService from '../../../services/user.service';
import { fetchUserError, fetchUserPending, fetchUserSuccess } from './user';

export const fetchUser =
    () =>
    async (dispatch: any): Promise<any> => {
        dispatch(fetchUserPending());
        try {
            const user: UserModel = await UserService.getUser();
            dispatch(fetchUserSuccess(user));
        } catch (e) {
            dispatch(fetchUserError(e));
        }
    };

export default fetchUser;
